export const ReportOfferReasons = {
    NOT_LOADING: { reasonCode: 'not_loading', description: 'Offer Not Loading' },
    NOT_PAYING: { reasonCode: 'not_paying', description: 'Offer Not Paying' },
    INAPPROPRIATE_CONTENT: { reasonCode: 'inappropriate_content', description: 'Inappropriate Content' },
    VIOLATES_TOS: { reasonCode: 'violates_tos', description: 'Violates Terms of Service' },
    VERY_DIFFICULT: { reasonCode: 'very_difficult', description: 'Very Difficult' },
    OTHER: { reasonCode: 'other', description: 'Other' },
};